<script setup lang="ts">
import { useI18n } from "@/app/composables/useI18n"
import moment from "moment"

defineProps({
  freeSpin: {
    type: Object,
    required: true,
  },
})

defineEmits(["click"])

const { t } = useI18n()
</script>

<template>
  <div>
    <router-link
      :to="{
        name: 'casino.game',
        params: { slug: freeSpin.free_spin_bet.game.slug },
        query: { currency: freeSpin.free_spin_bet.currency, action: 'play' },
      }"
      class="active-block" @click="$emit('click')"
    >
      <div class="text-container">
        <div class="active-title">
          <div>Free spin</div>
        </div>
        <div class="currency">
          <span>
            {{ freeSpin.free_spin_bet.game.name }} - {{ freeSpin.quantity_left }} pcs
          </span>
        </div>
        <div class="expires">
          Valid until {{ moment(freeSpin.valid_until).format("DD/MM/YYYY") }}
        </div>
      </div>
      <div class="play-btn" role="button">
        {{ t("casino.play") }}
      </div>
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.text-container {
  display: flex;
  flex-direction: column;
}

.currency-icon {
  width: 16px;
  height: 21px;
}

.active-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--be-big-card-bg);
  padding: 16px 40px 16px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;

    .play-btn {
      transform: scale(1.05);
    }
  }
}

.active-title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 11px;
  font-family: Poppins-reg;
}

.currency {
  display: flex;
  align-items: center;
  gap: 0 4px;
  font-family: Poppins-bold;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

.info-light {
  opacity: 0.3;
  cursor: pointer;
}

.expires {
  color: #fff;
  font-family: Poppins-reg;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.3;
  margin-top: 5px;
}
</style>
